import styled from 'styled-components'

export const BeneficiaryWrapper = styled.div`
  height: 300px;
  margin-top: 23px;
  font-family: ${({ theme }) => theme.fontFamily.inter};
`

export const BankDetails = styled.div`
  .user_bank {
    display: flex;
    width: 325px;
    align-items: center;
    color: ${({ theme }) => theme.colors.white};
    border-radius: 10px;
    height: 80px;
    border: 1px solid rgba(228, 228, 228, 0.6);
    cursor: pointer;
    .account_name_number {
      margin-left: 14px;
      margin-top: -10px;
    }
    .account {
      font-style: normal;
      font-weight: 500;
      font-size: ${({ theme }) => theme.fontSize.s};
      line-height: 140%;
      color: ${({ theme }) => theme.colors.AccountNumber};
    }
    .account_name {
      font-style: normal;
      font-weight: 500;
      font-size: ${({ theme }) => theme.fontSize.x11};
      line-height: 13px;
      color: ${({ theme }) => theme.colors.AccountDark};
      margin-top: -10px;
    }
  }

  .img_wrapper img {
    width: 48px;
    height: 48px;
  }
`

export const AddBankWrapper = styled.div`
  margin-top: 20px;

  .add_bank_link {
    font-weight: 600;
    font-style: normal;
    font-size: ${({ theme }) => theme.fontSize.s};
    line-height: 140%;
    color: ${({ theme }) => theme.colors.CollaboBlue};
  }
`

export const CheckOutBtnWrapper = styled.div``
